var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataTable',{attrs:{"selectable":false,"dense-view":false,"data":{
      header: _vm.tableHeader,
      body: _vm.tableBody,
    },"filters":_vm.filters,"max-items-per-page":50,"loading":_vm.isLoading,"hide-filters-when-empty":true,"empty-state-text":"No employees or contractors match this filter."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }